module.exports = __webpack_public_path__ + "img/ie.b5b8b5e3.svg";